import { render, staticRenderFns } from "./SettingMenu.vue?vue&type=template&id=2a85275e&scoped=true"
import script from "./SettingMenu.vue?vue&type=script&lang=js"
export * from "./SettingMenu.vue?vue&type=script&lang=js"
import style0 from "./SettingMenu.vue?vue&type=style&index=0&id=2a85275e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a85275e",
  null
  
)

export default component.exports